import React from 'react';
import { ShieldCheck, Users, Zap, Truck, CreditCard, Sparkles } from 'lucide-react';
import { whyUs } from '../mock';

const ICONS = [ShieldCheck, Users, Zap, Truck, CreditCard, Sparkles];

const WhyUs = () => {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-14 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-[color:var(--brand-50)] text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3">Keunggulan</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)]">
            Mengapa Harus <span className="text-[color:var(--brand)]">Trust Me Laundry?</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {whyUs.map((w, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div key={w.title} className="reveal group p-7 rounded-2xl bg-white border border-[color:var(--brand-50)] hover:border-[color:var(--brand)] hover:shadow-2xl transition-all duration-300" style={{ transitionDelay: `${i * 60}ms` }}>
                <div className="h-14 w-14 rounded-xl bg-[color:var(--brand-50)] flex items-center justify-center mb-5 group-hover:bg-[color:var(--brand)] transition-colors">
                  <Icon className="w-7 h-7 text-[color:var(--brand)] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display text-xl font-bold text-[color:var(--ink)] mb-2">{w.title}</h3>
                <p className="text-sm text-[color:var(--muted)] leading-relaxed">{w.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
